module.exports = __webpack_public_path__ + "static/media/icon-thumbs-up-down.81114e72.svg";